import { gql } from "@apollo/client";

const getUserOnline = gql`
  mutation getUserOnline($status: Boolean!) {
    getUserOnline(status: $status) {
      success
      error
      result
    }
  }
`;
export default getUserOnline;
